import { useModel } from "@bcm-dev/bcms-vite";
import ExternalIframe from 'components/shared/containers/ExternalIframe';
import PageContainer from 'components/shared/containers/PageContainer';
import { CenterContentContainer } from 'components/shared/containers/PageLayoutContainer';
import ContentHeaderView from 'components/shared/views/ContentHeaderView';
import ContentSubheaderView from 'components/shared/views/ContentSubheaderView';
import PageContentView from 'components/shared/views/PageContentView';
import React from 'react';
import "./styles.css";
/**
 * @function MyFiancesPage
 * @return {React.Component}
 * @note - Branding for this page is being added to the window object so captures can utilize the set value in state code
 * @exported true
 * @description The main component for MyFiancesPage
 */
export default function MyFiancesPage(props) {
  // Branding options needed for captures
  const options = useModel().branding.options;
  window.BRANDING = { "pfm21_abi22" : options.pfm21_abi22 };
  const subheaderText = options.myfinancess_subheader_abi22;
  const hasSubheaderText = subheaderText ? true : false;

  return (
    <PageContainer className="my-finances-page integrated-product-page" ignoreTrigger={ true }>
      <PageContentView title="My Finances">
        <CenterContentContainer>
          <ContentHeaderView text="My Finances"/>
          { hasSubheaderText && <ContentSubheaderView text={ subheaderText } /> }
          <div className="iframe-container flex-container flex-horizontal justify-center">
            {/* iFrame for PFM goes here */}
            <ExternalIframe className="my-finances-iframe" demo="PFM21" key="MyFiancesPage"/>
          </div>
        </CenterContentContainer>
      </PageContentView>
    </PageContainer>
  );
}